
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import config from 'config';
import ButtonLoader from 'LIBRARY/CommonResources/ButtonLoader/ButtonLoader';
import 'LIBRARY/Components/Reports/ResourceListAsPerAccessionNumber/ResourceListAsPerAccessionNumber.css';
import 'LIBRARY/Components/Reports/StudentWiseLibraryStatistics/StudentWiseLibraryStatistics.css';
import LibraryApiCall from 'LibraryApiCall';
import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import Pagination from 'react-js-pagination';
import ReactToPrint from 'react-to-print';

class CategoryWiseYearlyPurchaseWithCost extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            successModal: false,

            // All stock verification data
            pageIndex: 1,
            limit: "10",

            // report filter
            searchByInvoiceStartDate: '',
            searchByInvoiceEndDate: '',

            yearlyPurchaseWithCostData: {},
            yearlyPurchaseWithCostLoading: false,
            totalScannedResourceListItems: 0,

            //STATE FOR COLUMN VISIBILITY
            exportItemVisibilityForRows: [
                { name: "Category Name", isVisible: true },
                { name: "Number of Resources", isVisible: true },
                { name: "Cost", isVisible: true },
            ],

            //STATE FOR header
            exportCSVHeaders: [
                { name: "Category Name", key: 'verificationStatus' },
                { name: "Number of Resources", key: 'accessionSeries' },
                { name: "Cost", key: 'accessionNumber' },
            ],

            exportItemVisibility: [
                { name: "Category Name", isVisible: true },
                { name: "Number of Resources", isVisible: true },
                { name: "Cost", isVisible: true },
            ],

            // export all
            isExportAllReportDataFetching: false,
            allReportData: {},
            allSortedIdArray: [],
            sortedIdArray: [],

            // total count
            totalCostCount: 0,
            collectedFineCountForExport: 0,
            totalResourcesCountForExport: 0,
        };
    }

    componentDidMount() {
        this.formatCSVExportData('onLoad'); // export data
    }

    GetLibraryYearlyPerchaceResourceCountForReport = async () => {
        this.setState({
            yearlyPurchaseWithCostLoading: true
        });

        let filterParameter = {
            "startDate": this.state.searchByInvoiceStartDate,
            "endDate": this.state.searchByInvoiceEndDate,
        }

        let requestData = {
            'iid': config.institute_id,
            'pageIndex': this.state.pageIndex,
            "limitPerPage": this.state.limit,
            "filterParameter": filterParameter
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetLibraryYearlyPerchaceResourceCountForReport',
            requestData,
            '/api/library/instructor.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.GetLibraryYearlyPerchaceResourceCountForReport()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                // Use reduce to accumulate totals
                const totals = Object.values(apiResult.data).reduce((accumulator, resource) => {
                    const keyCollectedFine = resource.totalPrice || 0;
                    const keyTotalResource = resource.totalResources || 0;

                    // Accumulate totals
                    accumulator.totalCollectedFine += parseInt(keyCollectedFine);
                    accumulator.totalResources += parseInt(keyTotalResource);

                    return accumulator;
                }, {
                    totalCollectedFine: 0,
                    totalResources: 0
                });


                if (apiResult?.data) {
                    if (apiResult.success == 'true') {
                        this.setState({
                            yearlyPurchaseWithCostData: apiResult.data,
                            totalScannedResourceListItems: apiResult.totalRecords,
                            collectedFineCount: totals.totalCollectedFine,
                            totalResourcesCount: totals.totalResources,
                            yearlyPurchaseWithCostLoading: false
                        });
                    } else {
                        this.setState({
                            yearlyPurchaseWithCostData: {},
                            yearlyPurchaseWithCostLoading: false
                        });
                    }
                } else {
                    this.setState({
                        successModal: true,
                        successModalType: 'warning',
                        successMessage: apiResult.message,
                    });

                    this.setState({
                        yearlyPurchaseWithCostData: {},
                        yearlyPurchaseWithCostLoading: false
                    });
                }
            }
        }
    }

    // on change for show entries per page
    changeShowEntriesControl = (event) => {
        this.setState({
            pageIndex: 1, limit: event.target.value, searchByInvoiceStartDate: this.state.searchByInvoiceStartDate, searchByInvoiceEndDate: this.state.searchByInvoiceEndDate,
        }, () => {
            this.GetLibraryYearlyPerchaceResourceCountForReport();
        });
    }

    // on change for per page change
    updatePaginationCount = (pageNumber) => {
        this.setState({ pageIndex: pageNumber, searchByInvoiceStartDate: this.state.searchByInvoiceStartDate, searchByInvoiceEndDate: this.state.searchByInvoiceEndDate }, () => {
            this.GetLibraryYearlyPerchaceResourceCountForReport();
        });
    };

    // CLEAR ALL FILTER
    handleClearAllReportFilter = () => {
        this.setState({
            searchByInvoiceStartDate: '', searchByInvoiceEndDate: '', limit: "10", pageIndex: 1, yearlyPurchaseWithCostData: {}, yearlyPurchaseWithCostLoading: false,
        })
    };

    // column visibility on change
    updateColumnDisplay = (columnIndex) => {
        let exportItemVisibilityForRows = this.state.exportItemVisibilityForRows;

        exportItemVisibilityForRows[columnIndex].isVisible = !exportItemVisibilityForRows[columnIndex].isVisible;

        this.setState({
            exportItemVisibilityForRows
        });
    }

    //FUNCTION DEFINED TO INITIATE THE EXPORT DOWNLOAD PROCESS FOR DEPARTMENT LIST
    exportCSVData = () => {
        document.getElementById('export').click();
    }

    exportAllReportCSV = () => {
        document.getElementById('exportAll').click();
    }

    // FUNCTION TO FORMAT DATA BEFORE EXPORTING
    formatCSVExportData = (action) => {
        let exportSelectedCSVHeaders = this.state.exportSelectedCSVHeaders;

        exportSelectedCSVHeaders = [{ label: "Sr.No.", key: "srNo" },];

        this.state.exportCSVHeaders.map(csvInfo => {
            this.state.exportItemVisibility.map(columnInfo => {
                if (csvInfo.label == columnInfo.name) {
                    if (columnInfo.isVisible) {
                        exportSelectedCSVHeaders.push(csvInfo);
                    }
                }
            });
        });

        this.setState({
            exportSelectedCSVHeaders
        }, () => {
            if (action != 'onLoad') {
                this.exportCSVData();
            }
        });
    }

    // export all functionality
    returnExportAllData = () => {
        // display applied filters while exporting data
        let FilterArray = [];


        let filterScannedFromDate = this.state.searchByInvoiceStartDate
        let filterScannedToDate = this.state.searchByInvoiceEndDate


        if (filterScannedFromDate) {
            FilterArray.push(`Invoice Start Date - ${filterScannedFromDate}`)
        }

        if (filterScannedToDate) {
            FilterArray.push(`Invoice End Date - ${filterScannedToDate}`)
        }

        return (
            <table className="table table-bordered" id="ExportAllScannedResourceReport" style={{ marginTop: '15px', display: 'none' }}>
                <thead>
                    <tr>
                        <tr className='d-none'>
                            <th colSpan="4" style={{ textAlign: 'center' }}>
                                {config.institute_name}
                            </th>
                        </tr>
                        <tr className='d-none'>
                            <th colSpan="4" style={{ textAlign: 'center' }}>
                                Category Wise Yearly Purchase With Cost
                            </th>
                        </tr>
                        <tr className='d-none'>
                            <th colSpan="4" ></th>
                        </tr>
                        <tr className='d-none'>
                            <th colSpan="4" style={{ textAlign: 'center' }}>
                                {
                                    FilterArray.join(" | ")
                                }
                            </th>
                        </tr>
                        <tr className='d-none'>
                            <th colSpan="4" ></th>
                        </tr>
                        <th>Sr.No</th>
                        {this.state.exportItemVisibilityForRows[0].isVisible && <th>Category Name</th>}
                        {this.state.exportItemVisibilityForRows[1].isVisible && <th>Number of Resources</th>}
                        {this.state.exportItemVisibilityForRows[2].isVisible && <th>Cost</th>}
                    </tr>
                </thead>

                <tbody>
                    {
                        this.state.isExportAllReportDataFetching ?
                            <tr>
                                <td colSpan="4">
                                    <ButtonLoader />
                                </td>
                            </tr>
                            :
                            Object.keys(this.state.allReportData).length > 0 ?
                                (Object.values(this.state.allReportData).map((resource, index) => {
                                    return (

                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            {this.state.exportItemVisibilityForRows[0].isVisible && <td>{resource?.name || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[1].isVisible && <td>{resource?.totalResources || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[2].isVisible && <td>{resource?.totalPrice || ""}</td>}
                                        </tr>
                                    )
                                })) :
                                <tr>
                                    <td colSpan="4">
                                        No data found.
                                    </td>
                                </tr>
                    }

                    {
                        // display total count
                        Object.keys(this.state.allReportData).length > 0 ?
                            this.state.isExportAllReportDataFetching ? null :
                                <>
                                    <tr>
                                        <td style={{ textAlign: "right", fontWeight: "bold" }}>Total</td>
                                        <td colSpan="1"></td>
                                        {this.state.exportItemVisibilityForRows[1].isVisible && <td style={{ textAlign: "right", fontWeight: "bold" }}>
                                            {this.state.totalResourcesCountForExport}
                                        </td>}
                                        {/* total cost */}
                                        {this.state.exportItemVisibilityForRows[2].isVisible && <td style={{ textAlign: "right", fontWeight: "bold" }}>
                                            {this.state.collectedFineCountForExport}
                                        </td>}
                                    </tr>
                                </>
                            : null
                    }
                </tbody>
            </table>
        );
    };

    // METHOD TO GET EXPORT REPORT DATA RECURSIVELY
    methodToExportReportData = async (pageIndex) => {
        const { totalScannedResourceListItems, collectedFineCountForExport, totalResourcesCountForExport } = this.state;
        const totalPages = Math.ceil(totalScannedResourceListItems / 50);
        let allReportData = { ...this.state.allReportData };
        let allSortedIdArray = [...this.state.allSortedIdArray];

        pageIndex++; // Increment page index to fetch the next set of data

        if (pageIndex <= totalPages) {
            this.setState({
                isExportAllReportDataFetching: true
            });

            let filterParameter = {
                "startDate": this.state.searchByInvoiceStartDate,
                "endDate": this.state.searchByInvoiceEndDate,
            }

            let requestData = {
                'iid': config.institute_id,
                'pageIndex': pageIndex,
                "limitPerPage": 50,
                "filterParameter": filterParameter
            };

            let jsonResponse = await LibraryApiCall.makeApiCall(
                'GetLibraryYearlyPerchaceResourceCountForReport',
                requestData,
                '/api/library/instructor.php'
            );

            if (jsonResponse.expired) {
                setTimeout(() => {
                    this.methodToExportReportData(pageIndex);
                }, 1000);
            } else {
                if (jsonResponse.success) {
                    let apiResult = jsonResponse.APIResult.data;
                    let sortedResponseArrayFromApi = jsonResponse.APIResult.sortedIdArray || [];

                    // Page-wise total
                    const pageTotals = Object.values(apiResult).reduce((acc, resource) => {
                        acc.totalCollectedFine += Number(resource.totalPrice || 0);
                        acc.totalResources += Number(resource.totalResources || 0);
                        return acc;
                    }, {
                        totalCollectedFine: 0,
                        totalResources: 0
                    });

                    // Updated accumulated totals
                    const newCollectedFine = collectedFineCountForExport + pageTotals.totalCollectedFine;
                    const newTotalResources = totalResourcesCountForExport + pageTotals.totalResources;


                    // Concatenate new data and update state
                    this.setState({
                        allReportData: { ...allReportData, ...apiResult },
                        allSortedIdArray: [...allSortedIdArray, ...sortedResponseArrayFromApi],
                        totalRecords: jsonResponse.APIResult.totalRecords,
                        collectedFineCountForExport: newCollectedFine,
                        totalResourcesCountForExport: newTotalResources,
                    }, () => {

                        // Fetch the next page recursively
                        this.methodToExportReportData(pageIndex);
                    });
                } else {
                    this.setState({
                        isExportAllReportDataFetching: false,
                        successModal: true,
                        successModalType: 'error',
                        successMessage: 'Something went wrong while getting assessment data. Please try again later.'
                    });
                }
            }
        } else {
            // Final step when all pages are fetched
            this.setState({
                isExportAllReportDataFetching: false,
            }, () => {
                // Trigger any further actions after fetching all data
                setTimeout(() => {
                    this.exportAllReportCSV();
                }, 500);
            });
        }
    };

    render() {
        // display applied filters while exporting data
        let FilterArray = [];

        let filterScannedFromDate = this.state.searchByInvoiceStartDate
        let filterScannedToDate = this.state.searchByInvoiceEndDate

        if (filterScannedFromDate) {
            FilterArray.push(`Invoice Start Date - ${filterScannedFromDate}`)
        }

        if (filterScannedToDate) {
            FilterArray.push(`Invoice End Date - ${filterScannedToDate}`)
        }

        return (
            <div>
                <div className="pl-3 pr-3" style={{ height: '100%' }}>
                    <div style={{ height: '100%' }}></div>
                    <div className="studentStatisticalReport">
                        <div>
                            {/* header */}
                            <div className="card" style={{ marginTop: '20px', boxShadow: 'none', borderRadius: '7px 7px 0px 0px', border: '1px solid #E0E8EF', padding: '8px' }}>
                                <div className="d-flex col-md-12 px-0">
                                    <div className="col-md-10 d-flex justify-content-start align-items-center p-0">
                                        {/* action button - filter */}
                                        <div className="d-flex">
                                            <div>
                                                {/* filter data form*/}
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap', paddingLeft: '14px', justifyContent: 'space-between', paddingRight: '14px' }}>
                                                    <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '10px' }}>
                                                        {/* Based On invoice start date */}
                                                        <div className="mb-2  p-1">
                                                            <label className="vm_custom_body3" color='#454E52'>Invoice Start Date <span className='text-danger'>*</span></label>
                                                            <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                                <input
                                                                    type="date"
                                                                    className="form-control"
                                                                    style={{ fontSize: '14px', paddingLeft: '10px', paddingTop: '5px', paddingBottom: '6px' }}
                                                                    placeholder="Select Invoice Start Date"
                                                                    value={this.state.searchByInvoiceStartDate}
                                                                    onChange={(event) => {
                                                                        this.setState({
                                                                            searchByInvoiceStartDate: event.target.value || '', // Handle empty selection
                                                                        }, () => this.GetLibraryYearlyPerchaceResourceCountForReport()
                                                                        );
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>

                                                        {/* Based On invoice end date*/}
                                                        <div className="mb-2  p-1">
                                                            <label className="vm_custom_body3" color='#454E52'>Invoice End Date <span className='text-danger'>*</span></label>
                                                            <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                                <input
                                                                    type="date"
                                                                    className="form-control"
                                                                    style={{ fontSize: '14px', paddingLeft: '10px', paddingTop: '5px', paddingBottom: '6px' }}
                                                                    placeholder="Select Invoice End Date"
                                                                    value={this.state.searchByInvoiceEndDate}
                                                                    onChange={(event) => {
                                                                        this.setState({
                                                                            searchByInvoiceEndDate: event.target.value || '', // Handle empty selection
                                                                        }, () => this.GetLibraryYearlyPerchaceResourceCountForReport()
                                                                        );
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                                <p style={{ marginLeft: "20px", color: '#7A7A7A', fontSize: '12px' }}>Select "Invoice Date" to get Category Wise Yearly Purchase With Cost Report filter result.</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-2 d-flex justify-content-end align-items-center p-0">

                                        {Object.keys(this.state.yearlyPurchaseWithCostData).length == 0 ? null :
                                            <>
                                                <div className="d-flex">
                                                    {this.state.isExportAllReportDataFetching && <div><ButtonLoader /></div>}
                                                </div>

                                                {/* 1 action button - export data */}
                                                <div className="d-flex ml-2" title="Click to Export" >
                                                    <button className="btn outline-button" id='exportDropdownMenu' data-toggle="dropdown" aria-expanded="false" data-bs-toggle="dropdown" aria-haspopup="true" style={{ borderRadius: '5px', boxShadow: 'none' }}> <style type="text/css" media="print">
                                                        {"@page { size: auto; }"}
                                                    </style><FontAwesomeIcon size='lg' icon={["fa", "file-export"]} style={{ cursor: "pointer", color: '#0465AC' }} /></button>

                                                    {/* 2.1 action button option - export and export all */}
                                                    <div className="dropdown-menu" aria-labelledby='exportDropdownMenu'>
                                                        <span>
                                                            <div style={{ display: 'none' }}>
                                                                <ReactHTMLTableToExcel
                                                                    id="export"
                                                                    className="btn outline-button waves-effect text-capitalize"
                                                                    table="scannedResourceReport"
                                                                    filename="CategoryWiseYearlyPurchaseWithCostReport"
                                                                    sheet="tablexls"
                                                                    buttonText="Export to Excel "
                                                                >
                                                                </ReactHTMLTableToExcel>
                                                            </div>
                                                            <div style={{ display: 'none' }}>
                                                                <ReactHTMLTableToExcel
                                                                    id="exportAll"
                                                                    className="btn outline-button waves-effect text-capitalize"
                                                                    table="ExportAllScannedResourceReport"   // export all functionality
                                                                    filename="ExportAllCategoryWiseYearlyPurchaseWithCostReport"
                                                                    sheet="tablexls"
                                                                    buttonText="Export All to Excel"
                                                                />
                                                            </div>
                                                            <button
                                                                onClick={this.formatCSVExportData}
                                                                className="dropdown-item"
                                                                title="Click to Export"
                                                                style={{ boxShadow: 'none' }}
                                                            >
                                                                Export
                                                            </button>
                                                            {this.state.isExportAllReportDataFetching ? (
                                                                <p className="dropdown-item">
                                                                    Exporting report . . .&nbsp;
                                                                    <FontAwesomeIcon
                                                                        icon={["fas", "circle-notch"]}
                                                                        className="rotate"
                                                                    />
                                                                </p>
                                                            ) : (
                                                                <button
                                                                    onClick={() => this.setState({ allReportData: {} }, () => {
                                                                        this.methodToExportReportData(0)
                                                                    })}
                                                                    className="dropdown-item"
                                                                    title="Click to Export All"
                                                                    style={{ boxShadow: 'none' }}
                                                                >
                                                                    Export All
                                                                </button>
                                                            )}
                                                        </span>

                                                    </div>

                                                </div>

                                                {/* 2 action button - print */}
                                                <div className="d-flex ml-2" title="Click to Print">
                                                    <span className="print-button">
                                                        <ReactToPrint
                                                            trigger={() => {
                                                                return (
                                                                    <div className="print-button btn outline-button ml-2" style={{ borderRadius: '5px', boxShadow: 'none !important' }}>
                                                                        <style type="text/css" media="print">
                                                                            {"@page { size: auto; }"}
                                                                        </style>
                                                                        <span>
                                                                            <FontAwesomeIcon icon={['fas', 'print']} size='lg' title="Click to Print" style={{ cursor: "pointer", color: '#0465AC' }} />
                                                                        </span>
                                                                    </div>
                                                                )
                                                            }}
                                                            content={() => this.componentRef}
                                                        />
                                                    </span>
                                                </div>

                                                {/* 3 action button - column visibility */}
                                                <div className="d-flex ml-2" title="Click to Customize Columns">
                                                    <FontAwesomeIcon size='lg' id='settingsDropdownMenu' aria-expanded="false" data-toggle="dropdown" data-bs-toggle="dropdown" aria-haspopup="true" title="Click to Customize Columns" style={{ cursor: 'pointer', marginLeft: "8px", color: '#0465AC' }} color="#000" icon={['fas', 'cog']} />

                                                    {/* action modal - column visibility*/}
                                                    <div className="dropdown-menu vm-dropdown-menu" aria-labelledby='settingsDropdownMenu'>
                                                        <div id='settingDropdown' className='settingDropdown-body' style={{ height: '100px' }}>
                                                            {
                                                                this.state.exportItemVisibilityForRows.map((columnInfo, index) => {
                                                                    return (
                                                                        <p className="dropdown-item" style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px' }} key={columnInfo.name} onClick={() => this.updateColumnDisplay(index)}>
                                                                            <span style={{ marginRight: 10 }}>{columnInfo.name}</span>
                                                                            <input type="checkbox" checked={columnInfo.isVisible} />
                                                                        </p>
                                                                    );
                                                                })
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                    </div>
                                </div>
                            </div>
                            {
                                (this.state.searchByInvoiceStartDate !== '' || this.state.searchByInvoiceEndDate !== '') &&
                                <div className='filter-apply'>
                                    <p className='vm_custom_body5'>Filters are applied.</p>
                                    <p className="clear-all vm_custom_body5" onClick={this.handleClearAllReportFilter}>Clear All</p>
                                </div>
                            }
                        </div>

                        {/* list table */}
                        <div className="col-md-12 px-0 div_table">
                            <div className="table-responsive fixTableHead table_pad" id='tableResponsive'>
                                <div className="print-area" ref={el => this.componentRef = el}>
                                    <div className="buildingReport_logo">
                                        <img className="report-college-logo" alt="college-logo" src={config.instructorInfo.InstituteLogo} />
                                        <p className="report-college-name">{ReactHtmlParser(config.instructorInfo.InstituteName)}</p>
                                        <h3>Category Wise Yearly Purchase With Cost</h3>
                                        {
                                            FilterArray.join(" | ")
                                        }
                                    </div>
                                    <table className="table table-bordered  vm_libraryReport_table" id="scannedResourceReport">
                                        <thead>
                                            <tr>
                                                <tr className='d-none'>
                                                    <th colSpan="4" style={{ textAlign: 'center' }}>
                                                        {config.institute_name}
                                                    </th>
                                                </tr>
                                                <tr className='d-none'>
                                                    <th colSpan="4" style={{ textAlign: 'center' }}>
                                                        Category Wise Yearly Purchase With Cost
                                                    </th>
                                                </tr>
                                                <tr className='d-none'>
                                                    <th colSpan="4" ></th>
                                                </tr>
                                                <tr className='d-none'>
                                                    <th colSpan="4" style={{ textAlign: 'center' }}>
                                                        {
                                                            FilterArray.join(" | ")
                                                        }
                                                    </th>
                                                </tr>
                                                <tr className='d-none'>
                                                    <th colSpan="4" ></th>
                                                </tr>
                                                <th>Sr.No</th>
                                                {this.state.exportItemVisibilityForRows[0].isVisible && <th>Category Name</th>}
                                                {this.state.exportItemVisibilityForRows[1].isVisible && <th>Number of Resources</th>}
                                                {this.state.exportItemVisibilityForRows[2].isVisible && <th>Cost</th>}
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {
                                                this.state.yearlyPurchaseWithCostLoading ?
                                                    <tr>
                                                        <td colSpan="4">
                                                            <ButtonLoader />
                                                        </td>
                                                    </tr>
                                                    :
                                                    Object.keys(this.state.yearlyPurchaseWithCostData).length > 0 ?
                                                        (Object.values(this.state.yearlyPurchaseWithCostData).map((resource, index) => {
                                                            return (

                                                                <tr key={index}>
                                                                    <td>{
                                                                        this.state.limit === 'all' ? index + 1 :
                                                                            ((this.state.pageIndex - 1) * this.state.limit) + index + 1
                                                                    }</td>
                                                                    {this.state.exportItemVisibilityForRows[0].isVisible && <td>{resource?.name || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[1].isVisible && <td>{resource?.totalResources || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[2].isVisible && <td>{resource?.totalPrice || ""}</td>}
                                                                </tr>
                                                            )
                                                        })) :
                                                        <tr>
                                                            <td colSpan="4">
                                                                No data found.
                                                            </td>
                                                        </tr>
                                            }

                                            {
                                                // display total count
                                                Object.keys(this.state.yearlyPurchaseWithCostData).length > 0 ?
                                                    this.state.yearlyPurchaseWithCostLoading ? null :
                                                        <>
                                                            <tr>
                                                                <td style={{ textAlign: "right", fontWeight: "bold" }}>Total</td>
                                                                <td colSpan="1"></td>
                                                                {this.state.exportItemVisibilityForRows[1].isVisible && <td style={{ textAlign: "right", fontWeight: "bold" }}>
                                                                    {this.state.totalResourcesCount}
                                                                </td>}
                                                                {/* total cost */}
                                                                {this.state.exportItemVisibilityForRows[2].isVisible && <td style={{ textAlign: "right", fontWeight: "bold" }}>
                                                                    {this.state.collectedFineCount}
                                                                </td>}
                                                            </tr>
                                                        </>
                                                    : null
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            {/* table footer pagination */}
                            {
                                (Object.keys(this.state.yearlyPurchaseWithCostData).length > 0 || Object.keys(this.state.yearlyPurchaseWithCostData).length > this.state.limit) &&
                                <div className='row px-0'>
                                    <div className='col-md-12 px-0' style={{ background: "#f5f8fa", borderRadius: "4px" }}>
                                        <div className='row align-items-center justify-content-between'>
                                            <div className='col-lg-4 col-md-12 col-12 pl-0 hidePrint'>
                                                <div className='d-flex justify-content-lg-start justify-content-sm-center justify-content-center '>
                                                    <span className="d-flex align-items-center" style={{ fontSize: 14, marginLeft: 4 }}>
                                                        <select className="mx-2 p-1 vm_select_border" name="pageSize" id=""
                                                            value={this.state.limit}
                                                            onChange={this.changeShowEntriesControl}
                                                        >
                                                            <option value={10}>Entries Per Page 10</option>
                                                            <option value={25}>Entries Per Page 25</option>
                                                            <option value={40}>Entries Per Page 40</option>
                                                            <option value={100}>Entries Per Page 100</option>
                                                            <option value={250}>Entries Per Page 250</option>
                                                        </select>
                                                    </span>
                                                </div>
                                            </div>
                                            <div className='col-lg-4 col-md-12 col-12 justify-content-center'>
                                                <div id="paginationContainer" className="hidePrint" style={{ margin: "12px auto" }}>
                                                    <Pagination
                                                        activePage={this.state.pageIndex}
                                                        itemsCountPerPage={this.state.limit}
                                                        totalItemsCount={this.state.totalScannedResourceListItems}
                                                        pageRangeDisplayed={3}
                                                        onChange={this.updatePaginationCount}
                                                    />
                                                </div>
                                            </div>
                                            {
                                                this.returnExportAllData()
                                            }
                                            <div className='col-lg-4 col-md-12 col-12 pr-0 hidePrint'>
                                                <span className="d-flex justify-content-end align-items-center " style={{ fontSize: 14, marginRight: "21px" }}>
                                                    Total Records : {this.state.totalScannedResourceListItems || 0}
                                                </span>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div >
                </div>
            </div >

        );
    }
}


export default CategoryWiseYearlyPurchaseWithCost;